<template lang="pug">
  .hollow-guide-container(
    :style="hollowOutAreaStyle"
    :class="{ 'cashback-guide': guideStep === 2 }"
  )
    .hand-guide(:style="{ opacity: guideStep === 2 ? 1 : 0 }")
    .guide-banner(:style="guideBannerStyle")
    .guide-btn
      NextButton(
        text="下一步"
        @btnClick="handleNextClick"
        @skipClick="handleSkipClick"
      )
</template>

<script>
import { getUnit, safeJsonStringify } from '@/utils/tools';
import SPM from '../common/spm';
import NextButton from './next-button';

export default {
  name: 'HollowGuide',
  components: {
    NextButton,
  },
  props: {
    // 是否是新版兑换商品
    newExchange: {
      type: Boolean,
      default: false,
    },
    // 商品信息
    goodsInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      // 引导步骤
      guideStep: 1,
      // 镂空区域样式
      hollowOutAreaStyle: {
        top: '0rem',
        left: '0rem',
        width: '0rem',
        height: '0rem',
      },
    };
  },
  computed: {
    guideBannerStyle() {
      const { twoFramesUrl = '', threeFramesUrl = '' } = this.goodsInfo || {};
      const imageUrl = this.guideStep === 2 ? threeFramesUrl : twoFramesUrl;
      return {
        backgroundImage: `url(${imageUrl})`,
      };
    },
  },
  mounted() {
    this.hollowOutAreaStyle = {
      top: '0.8rem',
      left: '0.07rem',
      width: '3.62rem',
      height: this.newExchange ? '2.45rem' : '1.95rem',
    };
    // 重置页面滚动位置
    window.scrollTo({ top: 0 });

    // 镂空区域模块曝光埋点（第一步）
    SPM.moduleExpose({
      moduleId: 'newcus_second',
      contentId: 'newcus_second',
      businessInfo: {},
    });
  },
  methods: {
    // 下一步点击
    handleNextClick() {
      if (this.guideStep === 2) {
        this.$emit('nextClick');
        // 镂空区域模块点击埋点（下一步按钮点击）
        SPM.clickButton({
          buttonName: 'newcus_third',
          businessInfo: {},
        });
        return;
      }

      this.guideStep = 2;
      this.handleAnchorRakeBack();

      // 镂空区域模块点击埋点（下一步按钮点击）
      SPM.clickButton({
        buttonName: 'newcus_second',
        businessInfo: {},
      });
    },
    // 跳过点击
    handleSkipClick() {
      this.$emit('breakOff');
    },
    // 处理锚定购物返币
    handleAnchorRakeBack() {
      try {
        const target = document.querySelector('#welfare_rake_back');
        if (!target) {
          // 如果元素不存在，则中断引导流程
          this.$emit('breakOff');
          return;
        }

        const rect = target.getBoundingClientRect();
        const { top, left } = rect || {};
        const unit = getUnit();
        // 获取需要往上滚动的距离
        const scroll = this.domInViewport({ rect });
        // 设置镂空区域样式
        this.hollowOutAreaStyle = {
          width: '3.51rem',
          height: '2.52rem',
          left: `${left / unit}rem`,
          top: `${(top - scroll) / unit + 0.35}rem`,
        };

        // 镂空区域模块曝光埋点（第二步）
        SPM.moduleExpose({
          moduleId: 'newcus_third',
          contentId: 'newcus_third',
          businessInfo: {},
        });
      } catch (error) {
        // 如果出现异常，则中断引导流程
        this.$emit('breakOff');
        // eslint-disable-next-line no-console
        console.error('handleAnchorRakeBack => error', safeJsonStringify(error));
      }
    },
    // 判断dom是否在视口内
    domInViewport(options) {
      const { rect } = options || {};
      const { top, height } = rect || {};
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      // 判断dom是否全部在视口内
      const isInViewportOfFull = (top + height) <= viewportHeight;
      // 如果dom在视口内，则不需要滚动
      if (isInViewportOfFull) {
        return 0;
      }
      // 需要往上滚动的距离
      const scroll = (top + height) - viewportHeight;
      window.scrollTo({
        top: scroll,
        behavior: 'smooth',
      });
      return scroll;
    },
  },
};
</script>

<style lang="less" scoped>
.hollow-guide-container {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  border-radius: 0.18rem;
  box-shadow: 0 0 0 999rem rgba(0, 0, 0, 0.75);
  transition: all 0.5s ease-in-out;

  .hand-guide {
    position: absolute;
    left: 0;
    bottom: -0.23rem;
    width: 1.48rem;
    height: 1.23rem;
    background-image: url('https://m.hellobike.com/resource/gallery/833/Ts-zzqFF_Group%201707484238.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    transition: opacity 0.5s ease-in-out;
  }

  .guide-banner {
    position: absolute;
    left: 50%;
    bottom: -1.54rem;
    transform: translateX(-50%);
    width: 3.75rem;
    height: 1.4rem;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    transition: all 0.5s ease-in-out;
  }

  .guide-btn {
    position: absolute;
    left: 50%;
    bottom: -2.1rem;
    transform: translateX(-50%);
    transition: all 0.5s ease-in-out;
  }

  &.cashback-guide {
    .guide-banner {
      position: absolute;
      top: -1.49rem;
      background-image: url('https://m.hellobike.com/resource/gallery/833/kJksyLdI9Z.png');
    }

    .guide-btn {
      position: absolute;
      left: 50%;
      bottom: -0.7rem;
      transform: translateX(-50%);
    }
  }
}
</style>
